import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { apiInstance } from "@shared/services";

import { PAYFAC_QUERIES } from "./queries";

const URLS = {
  featureToggles: `/v2/payfac/feature-toggles`,
};

const api = apiInstance({
  enableBearerToken: true,
  enableXTokenApi: true,
});

export const useGetFeatureTogglesList = ({
  companyId,
}: {
  companyId?: string | number | null;
} = {}) => {
  const { t } = useTranslation();

  const getFeatureTogglesList = async (): Promise<{
    success: boolean;
    message: string;
    data?: string[];
  }> => {
    try {
      const { data } = await api.get<string[]>(URLS.featureToggles);

      return {
        success: true,
        message: t("payfac.featureTogglesServiceListSuccess"),
        data: Array.isArray(data) ? data : [],
      };
    } catch (error: any) {
      return {
        success: false,
        message:
          error?.response?.data?.message ||
          error?.response?.message ||
          t("payfac.featureTogglesServiceListError"),
      };
    }
  };

  return useQuery({
    queryKey: [PAYFAC_QUERIES.FEATURE_TOGGLES, companyId],
    queryFn: () => getFeatureTogglesList(),
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000,
  });
};
